import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getReceivingDetailFetchSuccess,
    getReceivingDetailFetchFailure,
    getReceivingDetailChangelogFetchSuccess,
    getReceivingDetailChangelogFetchFailure,
    createReceivingDetailFetchSuccess,
    createReceivingDetailFetchFailure,
    updateReceivingDetailFetchSuccess,
    updateReceivingDetailFetchFailure,
    patchReceivingDetailFetchSuccess,
    patchReceivingDetailFetchFailure,
    editReceivingDetailEshopNoteFetchSuccess,
    editReceivingDetailEshopNoteFetchFailure,
} from './reducer';
import { ReceivingDetailResType } from 'src/types/receivingDetail';
import { ReceivingType } from 'src/types/receiving';
import translate from '@translate';

const getReceivingDetailFetchRequest = async (idReceiving: string) => {
    const res = await api('get', `api/secure/receivings/${idReceiving}`);
    return res.data;
};

function* getReceivingDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: ReceivingDetailResType = yield call((): any => getReceivingDetailFetchRequest(action.payload));
        yield put(getReceivingDetailFetchSuccess(response));
    } catch (error) {
        yield put(getReceivingDetailFetchFailure({ error }));
    }
}

export function* getReceivingDetailFetchWatch() {
    yield takeEvery('receivingDetail/getReceivingDetailFetch', getReceivingDetailFetch);
}

const createReceivingDetailFetchRequest = async (data: ReceivingType) => {
    const res = await api('post', 'api/secure/receivings', data);
    return res.data;
};

function* createReceivingDetailFetch(action: { type: string; payload: ReceivingType }) {
    try {
        const response: ReceivingDetailResType = yield call((): any =>
            createReceivingDetailFetchRequest(action.payload)
        );
        yield put(
            createReceivingDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('receivings.message.receivingCreated') },
            })
        );
    } catch (error) {
        yield put(createReceivingDetailFetchFailure({ error }));
    }
}

export function* createReceivingDetailFetchWatch() {
    yield takeEvery('receivingDetail/createReceivingDetailFetch', createReceivingDetailFetch);
}

const updateReceivingDetailFetchRequest = async (params: { idReceiving: string; data: ReceivingType }) => {
    const res = await api('put', `api/secure/receivings/${params.idReceiving}`, params.data);
    return res.data;
};

function* updateReceivingDetailFetch(action: { type: string; payload: { idReceiving: string; data: ReceivingType } }) {
    try {
        const response: ReceivingDetailResType = yield call((): any =>
            updateReceivingDetailFetchRequest(action.payload)
        );
        yield put(
            updateReceivingDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('receivings.message.receivingUpdate') },
            })
        );
    } catch (error) {
        yield put(updateReceivingDetailFetchFailure({ error }));
    }
}

export function* updateReceivingDetailFetchWatch() {
    yield takeEvery('receivingDetail/updateReceivingDetailFetch', updateReceivingDetailFetch);
}

const patchReceivingDetailFetchRequest = async (params: { idReceiving: string; data: Partial<ReceivingType> }) => {
    const res = await api('patch', `api/secure/receivings/${params.idReceiving}`, params.data);
    return res.data;
};

function* patchReceivingDetailFetch(action: {
    type: string;
    payload: { idReceiving: string; data: Partial<ReceivingType> };
}) {
    try {
        const response: ReceivingDetailResType = yield call((): any =>
            patchReceivingDetailFetchRequest(action.payload)
        );
        yield put(
            patchReceivingDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('receivings.message.receivingUpdate') },
            })
        );
    } catch (error) {
        yield put(patchReceivingDetailFetchFailure({ error }));
    }
}

export function* patchReceivingDetailFetchWatch() {
    yield takeEvery('receivingDetail/patchReceivingDetailFetch', patchReceivingDetailFetch);
}

const editReceivingDetailEshopNoteFetchRequest = async (params: {
    idReceiving: string;
    data: { ESHOP_NOTE: string };
}) => {
    const res = await api('put', `api/secure/receivings/eshop-note/${params.idReceiving}`, params.data);
    return res.data;
};

function* editReceivingDetailEshopNoteFetch(action: {
    type: string;
    payload: { idReceiving: string; data: { ESHOP_NOTE: string } };
}) {
    try {
        const response: ReceivingDetailResType = yield call((): any =>
            editReceivingDetailEshopNoteFetchRequest(action.payload)
        );
        yield put(
            editReceivingDetailEshopNoteFetchSuccess({
                ...response,
                messageSuccess: { title: translate('receivings.message.receivingUpdate') },
            })
        );
    } catch (error) {
        yield put(editReceivingDetailEshopNoteFetchFailure({ error }));
    }
}

export function* editReceivingDetailEshopNoteFetchWatch() {
    yield takeEvery('receivingDetail/editReceivingDetailEshopNoteFetch', editReceivingDetailEshopNoteFetch);
}

const getReceivingDetailChangelogFetchRequest = async (idReceiving: string) => {
    const res = await api('get', `api/secure/receivings/changelog/${idReceiving}`);
    return res.data;
};

function* getReceivingDetailChangelogFetch(action: { type: string; payload: string }) {
    try {
        const response: ReceivingDetailResType = yield call((): any =>
            getReceivingDetailChangelogFetchRequest(action.payload)
        );
        yield put(getReceivingDetailChangelogFetchSuccess(response));
    } catch (error) {
        yield put(getReceivingDetailChangelogFetchFailure({ error }));
    }
}

export function* getReceivingDetailChangelogFetchWatch() {
    yield takeEvery('receivingDetail/getReceivingDetailChangelogFetch', getReceivingDetailChangelogFetch);
}
